export const isIos = () => {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') {
        return false;
    }
    return (/iP(hone|od|ad)/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
};
//# sourceMappingURL=isIos.js.map